import { render, staticRenderFns } from "./oneVone.vue?vue&type=template&id=e33a0e72&scoped=true"
import script from "./oneVone.vue?vue&type=script&lang=js"
export * from "./oneVone.vue?vue&type=script&lang=js"
import style0 from "./oneVone.vue?vue&type=style&index=0&id=e33a0e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33a0e72",
  null
  
)

export default component.exports